<template>
	<div class="page-detail-product">
		<div
			v-if="showConfirmModal"
			class="confirm-modal-container"
			:style="topLocation"
		>
			<app-modal
				:wholeSalePrice="wholeSalePrice"
				:product="productDetails"
				@close-modal="closeConfirmModal"
			></app-modal>
		</div>
		<div v-if="disabled" class="product-disabled">
			<h1 :style="`color:${globalColors.primary}`" class="sorry-text">
				Lo sentimos, este producto está desactivado :(
			</h1>
		</div>
		<div v-else class="detail-product-top">
			<product-view
				:data="productDetails"
				:images="productImages"
				class="container-product-view"
				@unit-selection="selectedUnit"
			/>
			<product-detail
				:disabled-order="disabledOrder"
				:disabled-buy="disabledBuy"
				:open-warehouse="stockWarehouse"
				:data="productDetails"
				:features="globalFeatures"
				:show-unity="Boolean(showUnity)"
				:stock-avaible="stockAvaible"
				:wholeSalePrice="wholeSalePrice"
				:exceed-quantity="exceedQuantity"
				:unit="unitProductValid"
				class="container-product-detail"
				@update="loadData"
				@selected="selectFeature"
				@clear="clearFeatures"
				@click-quantity="clickQuantity"
				@input-quantity="inputQuantity"
				@open-dialog="openDialog"
				@open-confirm-modal="showConfirmModal = true"
				@unit-selection="selectedUnit"
				@update-number="updateNumber"
			/>
		</div>
		<div v-if="!disabled" class="detail-tab-publicity">
			<product-publicity
				class="container-publicity desktop"
				:products-publicity="[]"
			/>
			<product-tab
				class="container-product-tab"
				:tabs="tabs"
				:sections="productDetails.sections"
				:lastIndex="lastIndex"
				:opinions="opinions"
				@update-opinion="loadOpinions"
			/>
		</div>
		<div>
			<product-related :relateds="relateds" v-if="relateds.length" />
		</div>
		<product-publicity class="container-publicity mobile" />
		<app-banner-top
			:data="getPromotionalBanner"
			:color="globalColors.secondary"
			big
		/>
		<warehouses-modal
			:dialog="dialogWarehouses"
			:rows="warehouses"
			@change-modal="closeModal"
		/>
	</div>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import ProductDetails from '@/class/productDetails';
import appBannerTop from '@/components/header/app-banner-top';
import productView from '@/components/products/product-view';
import productDetail from '@/components/products/product-detail';
import productTab from '@/components/products/product-tab';
import productRelated from '@/components/products/product-related';
import warehousesModal from '@/components/products/warehouses-modal';
import productPublicity from '@/components/products/product-publicity';
import appModal from '@/components/shared/modal/app-modal';
import helper from '@/shared/helper';
// import { setNewProperty, map } from '@/shared/lib';

async function created() {
	this.$loading(true);
	await this.loadProduct();
	if (this.$route.query.shoper) {
		// const tokenStringify = JSON.stringify(this.$route.query.token);
		// localStorage.setItem(`${process.env.STORAGE_USER_KEY}::token`, tokenStringify);
		// this.$store.dispatch('setToken', tokenStringify);
		// const orderId = JSON.stringify(this.$route.query.orderExternalId);
		// localStorage.setItem(`${process.env.STORAGE_USER_KEY}::orderExternal`, orderId);
		this.addToCar();
	}
	if (this.$route.query.pageLast) {
		const lastPage = JSON.stringify(this.$route.query.pageLast);
		localStorage.setItem('last-page-category', lastPage);
	}
}

function addToCar() {
	if (!this.noStock) {
		this.$store.dispatch('addProductToBuyCar', this.product);
		this.showConfirmModal = true;
		this.$store.commit('SET_IS_COLLAPSE_PRODUCT', true);
		this.goTo('buy');
	} else {
		this.showGenericError('Producto sin stock', 80000);
	}
}

function noStock() {
	return helper.noStock(this.product);
}

function mounted() {
	const ecommerceLocal = this.getLocalStorage('ecommerce::ecommerce-data');
	const company = this.getCommerceData.company
		? this.getCommerceData.company
		: ecommerceLocal.company;
	this.showUnity = company.settings ? company.settings.flagShowBaseUnit : false;
	// this.showUnity = true;
}

function isLoggedUser() {
	if (this.token) {
		return this.$httpProducts.get(`products/favorites/${this.id}`);
	}
	return this.$httpProductsPublic.get(`products-public/${this.id}?fromApp=2`);
}

async function loadProduct() {
	try {
		const { data: response } = await this.isLoggedUser();
		this.product = response;
		if (this.showUnity) {
			const { conversions } = this.product;
			const stock = helper.stockProductByType(this.product);
			const firstConversion = Object.keys(conversions || {})[0];
			const stockAvaible =
				firstConversion && stock !== Infinity
					? parseInt(stock / conversions[firstConversion].quantity, 10)
					: stock;
			this.stockAvaible = stockAvaible;
			this.$store.dispatch('setStock', this.stockAvaible);
		}
		this.updatePageTitle(this.product.name.toUpperCase());
		this.updateDescriptionTag(this.product.description);
		this.$store.dispatch('setRatingProductId', this.product.id);
		this.loadData(this.product.id);
		this.loadOpinions();
	} catch (error) {
		if (error.data.message === 'PRODUCT_NOT_FOUND') {
			this.disabled = true;
			this.showNotification('Este producto ya no está disponible', 'warning');
			this.$store.dispatch('LOAD_RELATED_PRODUCTS', {
				context: this,
				id: this.id,
			});
		} else {
			this.showGenericError();
		}
	}
}

async function loadData(id) {
	this.$store.dispatch('LOAD_RELATED_PRODUCTS', { context: this, id });
	const ecommerce = JSON.parse(
				localStorage.getItem('ecommerce::ecommerce-data'),
			);
	const commerceData = Object.keys(this.getCommerceData).length > 0 ? this.getCommerceData : ecommerce;
	const flagShowBaseUnit = commerceData.company.settings.flagShowBaseUnit;
	if (commerceData.settings && commerceData.settings.flagGrouper !== 2) {
		const requests = [
			this.$httpProductsPublic.get(`products-public/${id}/children`),
		];
		[{ data: this.childrens }] = await Promise.all(requests);
	}
	this.product.images = this.product.images.map((i, index) => {
		const newImage = { ...i };
		newImage.select = index === 0;
		return newImage;
	});
	const { discount } = Object.entries(this.product.priceList).flat()[1];
	let originalPrice = this.product.price;
	if (discount > 0) {
		originalPrice = (1 - discount / 100) * this.product.price;
	}

	this.product.quantity = 1;
	this.product.originalPrice = originalPrice;
	this.productFather = { ...this.product };
	this.tabs = this.product.sections.map(p => p.name);
	this.tabs.push('Comentarios');
	this.lastIndex = this.product.sections.length;
	const user =
		JSON.parse(localStorage.getItem('ecommerce::ecommerce-user')) || {};
	const commercePriceListId =
		user && user.salPriceListId ? user.salPriceListId : null;
	const priceListId = commercePriceListId || commerceData.settings.salPriceListId;
	this.productInstance = new ProductDetails(
		this.childrens,
		commerceData.settings.salPriceListId,
		commercePriceListId,
	);
	this.productInstance.firstProductSelected(this.product);
	this.globalFeatures = [...this.productInstance.getFeatures()];
	this.productDetails = { ...this.productInstance.getProductDetails() };
	if (this.productDetails.features && this.productDetails.features.length > 0) {
		this.stockAvaible = helper.stockProductByType(this.productDetails);
	}
	const conversions = this.productDetails.conversions || {};
	const units = this.productDetails.priceList[priceListId] && this.productDetails.priceList[priceListId].units || {};
	if (Object.keys(conversions).length > 0) {
		const conversionsFiltered = {};
		Object.keys(conversions).forEach(key => {
			if (units[key] && units[key].price > 0) {
				conversionsFiltered[key] = conversions[key];
			}
		});
		this.productDetails.conversions =
			Object.keys(conversionsFiltered).length > 0
				? conversionsFiltered
				: this.productDetails.conversions;
	}
	const selectedPriceList = this.product.priceList[priceListId];
	const unitKey = Object.keys(selectedPriceList.units)[0];
	if (flagShowBaseUnit === 1 && selectedPriceList && unitKey) {
		this.productDetails.unit = {
			...this.productDetails.conversions[Number(unitKey)],
			isSelected: false,
			id: Number(unitKey)
		};
		this.productDetails.unitSelected = Number(unitKey);
		this.product.unit = {
			...this.productDetails.conversions[Number(unitKey)],
			isSelected: false,
			id: Number(unitKey)
		};
		this.product.unitSelected = Number(unitKey);
	}
	this.priceOrigin = this.productDetails.priceDiscount;
	if (!Array.isArray(this.productDetails.sections)) {
		this.showNotification(
			'Se esta cargando mal la información del producto',
			'warning',
		);
	}
	this.getPriceList();
	this.productImages = [...this.productInstance.getImages()] || [];
	this.allFeatures = this.childrens.reduce(
		(acum, children) => acum.concat(children.features),
		[],
	);
	this.features = this.allFeatures.reduce((acum, feature) => {
		const index = acum.findIndex(a => a.name === feature.name);
		if (index > -1) {
			const indexValue = acum[index].values.findIndex(
				i => i.name === feature.value,
			);
			if (indexValue === -1) {
				const value = {
					name: feature.value,
					active: false,
					possible: false,
					disabled: false,
					code: feature.code,
				};
				acum[index].values.push(value);
			}
		} else {
			acum.push({
				name: feature.name,
				value: 'PADRE',
				values: [
					{
						name: feature.name,
						active: false,
						possible: false,
						disabled: true,
						code: 'PADRE',
					},
					{
						name: feature.value,
						active: false,
						possible: false,
						disabled: false,
						code: feature.code,
					},
				],
			});
		}
		return acum;
	}, []);
	if (this.childrens.length) {
		this.disabledBtn = true;
	}
	this.wholeSalePrice = this.productInstance.getWholeSalePrice();
	this.product.wholeSalePrice = this.wholeSalePrice;
}

function selectFeature(value) {
	this.productInstance.featureSelected(value);
	this.product.quantity = 1;
	this.globalFeatures = [...this.productInstance.getFeatures()];
	this.productImages = [...this.productInstance.getImages()];
	this.productDetails = { ...this.productInstance.getProductDetails() };
	if (this.productDetails.features && this.productDetails.features.length > 0) {
		this.stockAvaible = helper.stockProductByType(this.productDetails);
	}
}

function possibleFeature(possibles) {
	this.features = this.features.map((element, index) => {
		element.values.forEach((value, indexValue) => {
			if (this.productsFilter.length === 1) {
				const flag = possibles.filter(p => p.value === value.code);
				this.$set(
					this.features[index].values[indexValue],
					'active',
					!!flag.length,
				);
				this.$set(this.features[index].values[indexValue], 'possible', false);
				this.$set(
					this.features[index].values[indexValue],
					'disabled',
					!flag.length,
				);
				if (value.code === 'PADRE') {
					this.$set(this.features[index].values[indexValue], 'disabled', true);
				}
				if (value.active) {
					this.$set(this.features[index], 'value', value.code);
				}
			} else {
				const flag = possibles.filter(
					p => p.value === value.code && !value.active,
				);
				this.$set(
					this.features[index].values[indexValue],
					'possible',
					!!flag.length,
				);
				this.$set(
					this.features[index].values[indexValue],
					'disabled',
					!flag.length,
				);
			}
		});
		return element;
	});
	if (this.productsFilter.length === 1) {
		this.productsFilter[0].images = this.productsFilter[0].images.map(
			(i, index) => {
				const newImage = { ...i };
				newImage.select = index === 0;
				return newImage;
			},
		);
		this.assignProduct(this.productsFilter[0]);
		this.disabledBtn = false;
	}
}

function assignProduct(product) {
	this.product = { ...product };
	this.product.quantity = 1;
}

async function loadOpinions() {
	const params = {
		typeQuestionAnswer: 3,
		productId: this.product.id,
	};
	const { data: response } = process.env.PRODUCTS_READ_REPORT
		? await this.$httpProductsReadPublic.get('question-answer/public', {
				params,
		  })
		: await this.$httpProductsPublic.get('question-answer/public', { params });
	this.opinions = response;
	this.$loading(false);
}

function clearFeatures() {
	this.features = this.features.map(element => {
		const newElement = { ...element };
		newElement.value = 'PADRE';
		newElement.values = element.values.map(v => {
			const newValue = { ...v };
			newValue.active = false;
			newValue.possible = false;
			newValue.disabled = v.code === 'PADRE';
			return newValue;
		});
		return newElement;
	});
	this.featureSelect = [];
	this.arrayPossible = [];
	this.productsFilter = [];
	this.product = { ...this.productFather };
}

function newRoute() {
	this.loadProduct();
}

function updateNumber(quantity) {
	const newQuantity = parseInt(quantity, 10) || 1;
	const newProductdetail = { ...this.product };
	if (newQuantity <= 0 || quantity.includes('-')) {
		this.$set(newProductdetail, 'quantity', 1);
		this.product = { ...newProductdetail };
		this.productInstance.updateQuantity(1);
		this.productDetails = { ...this.productInstance.getProductDetails() };
		return;
	}

	const validQuantity = this.checkValidQuantity(newQuantity);
	this.quantityStock = parseInt(
		(this.unitProductValid.quantity || 1) * newQuantity,
		10,
	);

	if (this.quantityStock > helper.stockProductByType(this.product)) {
		this.showNotification(
			`El producto ${this.product.name} no cuenta con más stock en la presentación ${this.unitProductValid.name}.`,
			'warning',
		);
	} else if (validQuantity) {
		this.$set(newProductdetail, 'quantity', newQuantity);
		this.product = { ...newProductdetail };
		this.productInstance.updateQuantity(newQuantity);
		// this.getProductPrice();
		this.productDetails = { ...this.productInstance.getProductDetails() };
	} else {
		this.showNotification(`Cantidad: ${newQuantity} no disponible`, 'primary');
	}
}

function clickQuantity(value) {
	const priceDiscount = this.product.type === 5 ? this.productDetails.priceDiscount : this.product.priceDiscount;
	if (priceDiscount <= 0) {
		this.showNotification(
			'El producto no se puede agregar al carrito, porque su precio es 0.',
			'error',
			null,
		);
		return;
	}

	let num = this.product.quantity;
	const newProductdetail = { ...this.product };
	if (value === 'less' && num === 1) {
		num = 1;
	} else {
		num = value === 'more' ? (num += 1) : (num -= 1);
	}
	const validQuantity = this.checkValidQuantity(num);
	this.quantityStock = parseInt(
		(this.unitProductValid.quantity || 1) * num,
		10,
	);
	if (this.quantityStock > helper.stockProductByType(this.productDetails)) {
		this.showNotification(
			`El producto ${this.product.name} no cuenta con más stock en la presentación ${this.unitProductValid.name}.`,
			'warning',
		);
	} else if (validQuantity) {
		this.$set(newProductdetail, 'quantity', num);
		this.product = { ...newProductdetail };
		this.productInstance.updateQuantity(num);
		// this.getProductPrice();
		this.productDetails = { ...this.productInstance.getProductDetails() };
	} else {
		this.showNotification(`Cantidad: ${num} no disponible`, 'primary');
	}
}

function inputQuantity(num) {
	const newProductdetail = { ...this.product };
	const validQuantity = this.checkValidQuantity(num);
	if (validQuantity) {
		this.productInstance.updateQuantity(num);
		this.productDetails = { ...this.productInstance.getProductDetails() };
	} else {
		this.showNotification(
			`¡La cantidad de ${num} no está disponible!`,
			'primary',
		);
	}
	this.$set(newProductdetail, 'quantity', num);
	this.product = { ...newProductdetail };
}

function checkValidQuantity(quantity) {
	if (this.productInstance.isService || this.$allowOrderStockNegative) {
		return true;
	}
	const stockByProduct = helper.stockProductByType(this.product);
	// const { stock } = this.productInstance;
	const quantityCalc =
		this.productInstance.unit.quantity * quantity || quantity;
	this.exceedQuantity = !(stockByProduct >= quantityCalc);
	return stockByProduct >= quantityCalc;
}

async function openDialog() {
	const id = this.productDetails.id;
	try {
		const { data: response } = await this.$httpProductsPublic.get(
			`products-public/${id}/stock-by-warehouse`,
		);
		this.warehouses = response;
		this.dialogWarehouses = true;
	} catch (error) {
		this.showGenericError();
	}
}

function closeModal(value) {
	this.dialogWarehouses = value;
}

function selectedUnit(unit) {
	this.stockAvaible = parseInt(this.product.stockWarehouse / unit.quantity, 10);
	this.quantityStock = parseInt(
		(unit.quantity || 1) * this.product.quantity,
		10,
	);
	const unitDefault = {
		name: 'UNIDAD',
		quantity: 1,
	};
	this.unitProductValid = unit || unitDefault;
	this.exceedQuantity = this.quantityStock > this.product.stockWarehouse;
	if (this.noStock) {
		// const validQuantity = parseInt(this.product.stockWarehouse / unit.quantity, 10);
		// const newProductdetail = { ...this.product };
		// this.$set(newProductdetail, 'quantity', validQuantity);
		// this.product = { ...newProductdetail };
		// this.productInstance.updateQuantity(validQuantity);
		this.showNotification(
			`El producto ${this.product.name} no cuenta con más stock en la presentación ${unit.name}`,
			'warning',
		);
	} else {
		this.disabledBuy = false;
	}
	this.$store.dispatch('setStock', this.stockAvaible);
	this.productInstance.updateUnit(unit);
	this.productImages = [...this.productInstance.getImages()] || [];
	this.productDetails = { ...this.productInstance.getProductDetails() };
}

function closeConfirmModal() {
	this.showConfirmModal = false;
}

function topLocation() {
	return `top:${this.topModal}px`;
}

function disabledOrder() {
	if (this.showUnity) {
		// this.showGenericError('No se encuentre el stock suficiente');
		return !this.stockAvaible > 0;
	}
	return false;
}

function data() {
	return {
		allFeatures: [],
		arrayPossible: [],
		bannerTop: {
			urlImage:
				'https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/big.png',
			image: 'descuento',
		},
		childrens: [],
		cities: [],
		disabled: false,
		disabledBtn: false,
		dialogWarehouses: false,
		disabledBuy: false,
		exceedQuantity: false,
		features: [],
		featureSelect: [],
		featuresFather: [],
		globalFeatures: [],
		lastIndex: 0,
		opinions: [],
		product: {},
		productDetails: {
			conversions: {},
			wholeSalePrice: [],
		},
		productInstance: {},
		productsFilter: [],
		productImages: [],
		productFather: {},
		showUnity: false,
		showConfirmModal: false,
		stockWarehouse: false,
		quantityStock: 0,
		stockAvaible: 0,
		tabs: [],
		unitProductValid: {},
		warehouses: [],
		wholeSalePrice: [],
		totalPriceProduct: 0,
		priceOrigin: null,
	};
}

export default {
	name: 'page-detail-product',
	created,
	components: {
		appBannerTop,
		appModal,
		productDetail,
		productPublicity,
		productView,
		productTab,
		productRelated,
		warehousesModal,
	},
	computed: {
		...mapGetters(['getCommerceData', 'getPromotionalBanner', 'token']),
		...mapGetters('loading', ['isLoading']),
		...mapState({
			relateds: state => state.products.relateds,
			topModal: state => state.topLocationModal,
		}),
		disabledOrder,
		topLocation,
		noStock,
	},
	data,
	mounted,
	methods: {
		...mapActions('loading', {
			$loading: 'SET_LOADING_FLAG',
		}),
		assignProduct,
		addToCar,
		checkValidQuantity,
		clearFeatures,
		updateNumber,
		clickQuantity,
		closeConfirmModal,
		closeModal,
		isLoggedUser,
		loadData,
		loadOpinions,
		loadProduct,
		newRoute,
		openDialog,
		possibleFeature,
		selectFeature,
		selectedUnit,
		inputQuantity,
		getPriceList() {
			const user = JSON.parse(
				localStorage.getItem('ecommerce::ecommerce-user'),
			);

			const ecommerce = JSON.parse(
				localStorage.getItem('ecommerce::ecommerce-data'),
			);

			let salPriceListDefault =
				ecommerce && ecommerce.settings && ecommerce.settings.salPriceListId;

			if (user && user.salPriceListId) {
				salPriceListDefault = user.salPriceListId;
			}

			const priceListDefault = this.productDetails.priceList[
				salPriceListDefault
			];
			const priceList = Object.entries(priceListDefault.units).map(
				([id, unit]) => ({
					id,
					...unit,
				}),
			);
			if (this.$flagShowBaseUnit === 1 && priceList.length > 0) {
				this.productDetails.priceDiscount = priceList[0].price;
			}
		},
		// updateNumber(num) {
		// 	this.productDetails.quantity = Number(num);
		// 	const priceList = this.productDetails.priceList
		// 		? Object.values(this.productDetails.priceList)
		// 		: null;
		// 	if (priceList && priceList[0].ranges.length) {
		// 		const range = priceList[0].ranges.find(
		// 			r => Number(num) >= r.from && Number(num) <= r.to,
		// 		);
		// 		this.productDetails.priceDiscount = range
		// 			? range.price
		// 			: this.priceOrigin;
		// 	}
		// },
	},
	props: {
		id: {
			type: [Number, String],
		},
	},
	watch: {
		$route: newRoute,
	},
};
</script>
<style lang="scss" scoped>
.container-product-view {
	flex: 1 1 50%;
	margin-right: 15px;

	@media screen and (max-width: 996px) {
		flex: 1 1 100%;
		margin-right: 0;
	}
}

.page-detail-product {
	background: color(white);
	position: relative;

	@media screen and (max-width: 996px) {
		padding-top: 29px;
	}
}

.detail-product-top {
	display: flex;
	justify-content: space-between;
	margin-bottom: 92px;
	padding: 53px 7% 0;

	@media screen and (max-width: 996px) {
		flex-direction: column;
		margin-bottom: 35px;
		padding: 0 5px;
	}
}

.container-product-detail {
	flex: 1 1 40%;
	margin-left: 15px;

	@media screen and (max-width: 996px) {
		flex: 1 1 100%;
		margin-left: 0;
	}
}

.container-product-tab {
	flex: 1 1 70%;
}

.container-publicity {
	flex: 1 1 30%;
	margin-right: 29px;
}

.detail-tab-publicity {
	display: flex;
	justify-content: space-between;
	padding: 0 3%;

	@media screen and (max-width: 764px) {
		flex-direction: column;
		padding: 0;
	}
}

.mobile {
	display: none;
	@media screen and (max-width: 764px) {
		display: block;
	}
}

.desktop {
	@media screen and (max-width: 764px) {
		display: none;
	}
}

.container-general-tab {
	padding: 0 7%;

	@media screen and (max-width: 764px) {
		padding: 0 5%;
	}
}

.confirm-modal-container {
	background-color: white;
	border: 1px solid color(border);
	border-radius: 8px;
	box-shadow: 0 2px 4px 0 rgba(213, 213, 213, 0.5);
	margin-top: 1rem;
	padding: 10px;
	position: fixed;
	right: 37px;
	width: 350px;
	z-index: 2;
}

.product-disabled {
	align-items: center;
	display: flex;
	height: 300px;
	justify-content: center;
}

.sorry-text {
	margin: 0 20px;
	text-align: center;
}
</style>






// WEBPACK FOOTER //
// src/pages/page-detail-product.vue